import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuthStatus from "../../hooks/useAuthStatus";   // ← Added
import PersonalInfoModal from "./components/PersonalInfoModal";
import SupportModal from "./components/SupportModal";
import KYCModal from "./components/KYCModal";
import TermsPrivacyModal from "./components/TermsPrivacyModal";
import MobileBottomNav from "../../components/feature/MobileBottomNav";
import { getUser } from "../../api/apiServices";
import { toast } from "react-toastify";
import { useAuth } from "../../context/useAuth";

export default function Profile() {
  const navigate = useNavigate();
  const isAuthenticated = useAuthStatus();   // ← Added
  const { logout } = useAuth(); 

  const [notifications, setNotifications] = useState(true);
  const [biometrics, setBiometrics] = useState(false);
  const [showPersonalInfo, setShowPersonalInfo] = useState(false);
  const [showSupport, setShowSupport] = useState(false);
  const [user, setUser] = useState(null);
  const [showKYC, setShowKYC] = useState(false);
  const [showTerms, setShowTerms] = useState(false);


  const handleLogout = async () => {
    try {
      await logout();
      navigate("/auth")
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  useEffect(() => {
      userProfile()
    }, []);

  const menuItems = [
    { icon: "ri-user-line", label: "Personal Information", sub: "Name, phone, email", color: "#059669", action: () => setShowPersonalInfo(true) },
    { 
      icon: "ri-shield-keyhole-line", 
      label: "KYC Verification", 
      sub: user?.kycVerified ? "Verification Complete" : "Action Required", 
      badge: user?.kycVerified ? "verified" : "unverified", 
      color: user?.kycVerified ? "#059669" : "#F59E0B", 
      // Updated Action Logic
      action: () => {
        if (user?.kycVerified) {
          toast.warn("You are verified already!"); 
          // Note: You could also use a nice toast notification here
        } else {
          navigate("/kyc");
        }
      }
    },
    // { icon: "ri-lock-password-line", label: "Change Password", sub: "Update your password", color: "#8B5CF6", action:() => {navigate("/reset-password")} },
    { icon: "ri-customer-service-2-line", label: "Support", sub: "Help & contact us", color: "#F59E0B", action:() => {navigate("/support")} },
    { icon: "ri-file-list-3-line", label: "Terms & Privacy", sub: "Legal documents", color: "#6B7280", action:() => {navigate("/terms-privacy")} },
  ];

  // Disable actions when not authenticated
  const handleMenuAction = (action) => {
    if (!isAuthenticated) {
      navigate("/auth");
      return;
    }
    if (action) action();
  };

  const userProfile = async() =>{
    try {
      const data = await getUser()
      if(data?.status){
        setUser(data.user)
      }
    } catch (error) {
      console.log("Error fetching user: ", error?.response?.data?.message)
    }
  }

  return (
    <div className="min-h-screen bg-[#F7F8FA] pb-28">
      {/* Header */}
      <div className="bg-white px-5 pt-12 pb-5 border-b border-slate-100 flex items-center justify-between">
        <h1 className="text-slate-800 font-bold text-xl" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          Profile
        </h1>

        {!isAuthenticated && (
          <button
            onClick={() => navigate("/auth")}
            className="px-5 py-2 text-sm font-semibold text-emerald-600 border border-emerald-200 rounded-xl hover:bg-emerald-50 transition-colors"
          >
            Sign In
          </button>
        )}
      </div>

      {/* User Card with Lock Overlay */}
      <div className="mx-5 mt-4 relative">
        {!isAuthenticated && (
          <div className="absolute inset-0 bg-white/95 backdrop-blur-md z-10 flex items-center justify-center rounded-2xl border border-slate-200">
            <div className="text-center px-6">
              <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-slate-100 flex items-center justify-center">
                <i className="ri-lock-2-line text-slate-400 text-5xl"></i>
              </div>
              <p className="font-semibold text-slate-700 text-lg mb-1">Sign in to view profile</p>
              <p className="text-slate-500 text-sm mb-6">Your personal information is secure</p>
              <button
                onClick={() => navigate("/auth")}
                className="px-8 py-3 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold rounded-2xl text-sm flex items-center gap-2 mx-auto transition-colors"
              >
                <i className="ri-login-box-line"></i>
                Sign in to Unlock
              </button>
            </div>
          </div>
        )}

        <div className={`bg-white border border-slate-100 rounded-2xl px-5 py-5 flex items-center gap-4 mb-4 ${!isAuthenticated ? 'blur-sm pointer-events-none' : ''}`}>
          <div className="w-16 h-16 rounded-full bg-emerald-100 border-2 border-emerald-200 flex items-center justify-center flex-shrink-0">
            <span className="text-emerald-700 font-bold text-2xl">
              {user ? user.firstName.charAt(0) : <i className="ri-loader-4-line animate-spin" />}
            </span>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-slate-800 font-bold text-base truncate" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
              {user?.firstName}
            </p>
            <p className="text-slate-400 text-xs truncate">{user?.email}</p>
            <p className="text-slate-400 text-xs">{user?.phone}</p>
          </div>
          <div className={`flex items-center gap-1 px-2 py-1 rounded-full flex-shrink-0 border ${
        user?.kycVerified 
          ? "bg-emerald-50 border-emerald-100" 
          : "bg-amber-50 border-amber-100"
      }`}>
        <i className={`${user?.kycVerified ? "ri-shield-check-line text-emerald-600" : "ri-shield-warning-line text-amber-600"} text-xs`}></i>
        <span className={`${user?.kycVerified ? "text-emerald-600" : "text-amber-600"} text-xs font-semibold`}>
          {user?.kycVerified ? "Verified" : "Unverified"}
        </span>
      </div>
        </div>
      </div>

      {/* Referral Section with Lock */}
      <div className="mx-5 relative mb-4">
        {!isAuthenticated && (
          <div className="absolute inset-0 bg-white/95 backdrop-blur-md z-20 flex items-center justify-center rounded-2xl border border-slate-200" />
        )}

        <div className={`bg-emerald-600 rounded-2xl px-4 py-4 ${!isAuthenticated ? 'blur-sm pointer-events-none' : ''}`}>
          <div className="flex items-center justify-between mb-3">
            <div>
              <p className="text-white text-sm font-bold" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>Refer &amp; Earn</p>
              <p className="text-emerald-200 text-xs mt-0.5">Share your code, earn ₦500 per referral</p>
            </div>
            <i className="ri-gift-line text-white text-2xl"></i>
          </div>
          <div className="flex items-center gap-2 bg-white/20 rounded-xl px-3 py-2">
            <span className="text-white font-mono text-sm font-bold flex-1">{user?.referralCode}</span>
            <button className="w-8 h-8 flex items-center justify-center cursor-pointer bg-white/20 rounded-lg">
              <i className="ri-file-copy-line text-white text-sm"></i>
            </button>
          </div>
        </div>
      </div>

      {/* Toggles with Lock */}
      {/* <div className="mx-5 relative mb-4">
        {!isAuthenticated && (
          <div className="absolute inset-0 bg-white/95 backdrop-blur-md z-20 flex items-center justify-center rounded-2xl border border-slate-200" />
        )}

        <div className={`bg-white border border-slate-100 rounded-2xl px-4 divide-y divide-slate-50 ${!isAuthenticated ? 'blur-sm pointer-events-none' : ''}`}>
          <div className="flex items-center justify-between py-4">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-xl bg-amber-50 flex items-center justify-center">
                <i className="ri-notification-3-line text-amber-500 text-lg"></i>
              </div>
              <div>
                <p className="text-slate-700 text-sm font-medium">Push Notifications</p>
                <p className="text-slate-400 text-xs">Trade alerts &amp; updates</p>
              </div>
            </div>
            <button 
              onClick={() => isAuthenticated && setNotifications(!notifications)} 
              disabled={!isAuthenticated}
              className={`w-12 h-6 rounded-full transition-all cursor-pointer relative ${notifications ? "bg-emerald-500" : "bg-slate-200"}`}
            >
              <span className={`absolute top-0.5 w-5 h-5 bg-white rounded-full transition-all shadow-sm ${notifications ? "left-6" : "left-0.5"}`}></span>
            </button>
          </div>
          <div className="flex items-center justify-between py-4">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-xl bg-violet-50 flex items-center justify-center">
                <i className="ri-fingerprint-line text-violet-500 text-lg"></i>
              </div>
              <div>
                <p className="text-slate-700 text-sm font-medium">Biometric Login</p>
                <p className="text-slate-400 text-xs">Fingerprint / Face ID</p>
              </div>
            </div>
            <button 
              onClick={() => isAuthenticated && setBiometrics(!biometrics)} 
              disabled={!isAuthenticated}
              className={`w-12 h-6 rounded-full transition-all cursor-pointer relative ${biometrics ? "bg-emerald-500" : "bg-slate-200"}`}
            >
              <span className={`absolute top-0.5 w-5 h-5 bg-white rounded-full transition-all shadow-sm ${biometrics ? "left-6" : "left-0.5"}`}></span>
            </button>
          </div>
        </div>
      </div> */}

      {/* Menu Items with Lock */}
      <div className="mx-5 relative mb-4">
        {!isAuthenticated && (
          <div className="absolute inset-0 bg-white/95 backdrop-blur-md z-20 flex items-center justify-center rounded-2xl border border-slate-200" />
        )}

        <div className={`bg-white border border-slate-100 rounded-2xl px-4 divide-y divide-slate-50 ${!isAuthenticated ? 'blur-sm pointer-events-none' : ''}`}>
          {menuItems.map(item => (
           <button 
              key={item.label} 
              onClick={() => handleMenuAction(item.action)} // Use handleMenuAction here
              className="w-full flex items-center gap-3 py-4 text-left cursor-pointer transition-colors hover:bg-slate-50"
            >
              <div className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: `${item.color}15` }}>
                <i className={`${item.icon} text-lg`} style={{ color: item.color }}></i>
              </div>
              <div className="flex-1">
                <p className="text-slate-700 text-sm font-medium">{item.label}</p>
                <p className="text-slate-400 text-xs">{item.sub}</p>
              </div>
              {item.badge === "verified" && (
                <span className="text-emerald-600 text-xs bg-emerald-50 border border-emerald-100 px-2 py-0.5 rounded-full font-medium">
                  Verified
                </span>
              )}
              {item.badge === "unverified" && (
                <span className="text-amber-600 text-xs bg-amber-50 border border-amber-100 px-2 py-0.5 rounded-full font-medium">
                  Pending
                </span>
              )}
              {!item.badge && <i className="ri-arrow-right-s-line text-slate-300 text-lg"></i>}
            </button>
          ))}
        </div>
      </div>

      {/* Sign Out Button */}
      <div className="px-5">
        <button 
          onClick={handleLogout} 
          className="w-full py-4 rounded-2xl border border-red-200 bg-red-50 text-red-500 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-red-100 transition-colors flex items-center justify-center gap-2"
        >
          <i className="ri-logout-box-r-line"></i> 
          {isAuthenticated ? "Sign Out" : "Sign In"}
        </button>
      </div>

      <MobileBottomNav />

      {/* Modals - Only show when authenticated */}
      {isAuthenticated && user && (
        <>
        <PersonalInfoModal
        isOpen={showPersonalInfo}
        user={user}
        onClose={() => setShowPersonalInfo(false)}
        onUpdateSuccess={(updatedUser) => setUser(updatedUser)}
        />

          <SupportModal
            isOpen={showSupport}
            onClose={() => setShowSupport(false)}
          />

          <KYCModal
            isOpen={showKYC}
            onClose={() => setShowKYC(false)}
          />

          <TermsPrivacyModal
            isOpen={showTerms}
            onClose={() => setShowTerms(false)}
          />
        </>
      )}
    </div>
  );
}